import { createContext } from 'react';

const InventoryTableContext = createContext({
    onCellChange: () => {}
});

export default InventoryTableContext;
